<template>
  <div class="modal_backdrop" v-if="visible">
    <div class="modal_card">
      <!-- Icon Badge -->
      <div class="icon_badge">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 20h9"></path>
          <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
        </svg>
      </div>

      <!-- Title & Subtitle -->
      <h3 class="modal_title">
        Rename {{ targetItem && targetItem.is_folder ? 'Folder' : 'File' }}
      </h3>
      <p class="modal_subtitle">Enter a new name for this item.</p>

      <!-- Input Form -->
      <form @submit.prevent="onConfirm">
        <div class="form_group mb-3">
          <input
            type="text"
            class="form_input"
            v-model.trim="itemName"
            v-validate="'required'"
            name="itemName"
            placeholder="Enter name"
            :class="{ 'is_invalid': errors && errors.has('itemName') }"
            autocomplete="off"
          />
          <small class="error_text" v-if="errors && errors.has('itemName')">
            {{ errors.first('itemName') }}
          </small>
        </div>

        <!-- Action Buttons -->
        <div class="btn_group">
          <button type="button" class="btn_cancel" @click="onCancel" :disabled="loading">
            Cancel
          </button>
          <button type="submit" class="btn_confirm" :disabled="loading || !itemName.trim()">
            <i class="fa fa-spinner fa-spin mr-1" v-if="loading"></i>
            {{ loading ? 'Saving...' : 'Save' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BriefcaseUpdateModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    targetItem: {
      type: Object,
      default: () => ({})
    },
    isShared: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      itemName: ''
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.itemName = this.targetItem && this.targetItem.name ? this.targetItem.name : '';
        if (this.$validator) {
          this.$validator.reset();
        }
      }
    }
  },
  methods: {
    onCancel() {
      this.$emit('close');
    },
    onConfirm() {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) return;
        this.$emit('confirm', {
          item: this.targetItem,
          newName: this.itemName,
          isShared: this.isShared
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.modal_backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.78);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;

  .modal_card {
    background: #000000;
    width: 90%;
    max-width: 440px;
    border-radius: 14px;
    padding: 32px 28px 28px;
    text-align: center;
    box-shadow: 0 0 18px 2px rgba(220, 160, 20, 0.55);
    border: 1px solid rgba(220, 160, 20, 0.3);

    .icon_badge {
      width: 56px;
      height: 56px;
      margin: 0 auto 18px;
      border-radius: 50%;
      background: rgba(56, 139, 253, 0.12);
      border: 1px solid rgba(56, 139, 253, 0.25);
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        stroke: #388bfd;
      }
    }

    .modal_title {
      color: #ffffff;
      font-size: 19px;
      font-weight: 600;
      margin-bottom: 8px;
      letter-spacing: -0.2px;
    }

    .modal_subtitle {
      color: #94a3b8;
      font-size: 13px;
      margin-bottom: 22px;
    }

    .form_group {
      margin-bottom: 22px;
      text-align: left;

      .form_input {
        width: 100%;
        background: rgba(255, 255, 255, 0.08);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        color: #ffffff;
        padding: 10px 14px;
        font-size: 14px;
        font-weight: 500;
        outline: none;
        transition: border-color 0.2s ease;

        &:focus {
          border-color: #ffd400;
          color: #ffd400;
        }

        &.is_invalid {
          border-color: #ef4444;
        }
      }

      .error_text {
        color: #ef4444;
        font-size: 12px;
        margin-top: 4px;
        display: block;
      }
    }

    .btn_group {
      display: flex;
      gap: 14px;
      justify-content: center;

      button {
        flex: 1;
        padding: 10px 18px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        border: none;
        transition: all 0.2s ease;
        outline: none;

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      }

      .btn_cancel {
        background: rgba(255, 18, 18, 0.5);
        color: #ffffff;

        &:hover:not(:disabled) {
            background: #ffe738;
            color: #22292f;
        }
      }

      .btn_confirm {
        background: rgba(33, 228, 0, 0.5);
        color: #ffffff;

        &:hover:not(:disabled) {
            background: #ffe738;
            color: #22292f;
        }
      }
    }
  }
}
</style>